import React from 'react'
import { withRouter } from 'react-router-dom';
import { localizer, changeLanguage } from '../../Translator'

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'

import { PassStrength } from '../password/PassStrength'
import InvitationSignup from './InvitationSignup'

import { GridHeaderComponent } from '../common/HeaderComponentStyled.js'

import AuthCli from '../../sdk/AuthCli';

/**
 * Top layout for the signup by invitation screen.
 */
export class SignupLayout extends React.Component {

  constructor(props) {
    super(props)
    this.state = {

      // E-mail address being invited, extracted from the URL.
      invitedEmail: '',

      // Invitation token as extracted from the URL.
      invitedToken: '',

      // Pass through password as being typed by the user.
      passwordAttempt: '',

      // Result of checking validity of the password being typed.
      passwordAttemptValidated: false,

      // Used to wait until the desired language is loaded.
      isLoading: false,
    }
  }

  /**
   * Takes the query parameters where the invitation token and invited e-mail address are.
   */
  async componentDidMount() {
    // Extract the invitation token from the URL.
    var invitationToken = new URLSearchParams(this.props.location.search).get("token")
    var invitationEmail = new URLSearchParams(this.props.location.search).get("email")
    if (invitationToken == null) return;
    if (invitationEmail == null) return;

    // Show this initial screen to the user in the specified language (if present).
    var language = new URLSearchParams(this.props.location.search).get("culture")
    if (language !== null) {
      this.setState({ isLoading: true })
      await changeLanguage(language)

      // Force the whole app to refresh in the new language.
      var handler = this.props.onLanguageChange
      if (handler != null) handler(language)
    }
    this.setState({
      invitedEmail: invitationEmail,
      invitedToken: invitationToken
    })

    // Check against the server whether the invitation token is valid, not yet used.
    await AuthCli.GetInvitation(invitationToken).then(invitation => {
      this.setState({ isLoading: false })
      if (invitation === null) {
        // Received a null invitation object means that the passed invitation does not exist or is invalid.
        // Redirect to login screen.
        this.props.history.push("login");
      }
    })
  }

  render() {
    return (
      <React.Fragment>

        {/* Screen heading title. */}
        
        <Container className="pl-18 pr-18 pb-12 pt-55 ">
          {/* Screen heading title. */}
          <GridHeaderComponent container direction="row" spacing={4}>
            <Grid item md={12}>
              <Typography className="typography-generic header-title"><i className="fa-solid fa-key icon-button-header" /> {localizer.WelcomeSignup}</Typography>
            </Grid>
          </GridHeaderComponent>
          
          <Grid container direction="row" justify="center" alignItems="center" alignContent="center" spacing={4} className="container-generic">
            <Grid item md={12}>
              <Typography className="typography-generic">{localizer.WelcomeSignupDescription}</Typography>
            </Grid>
            {/* Form to type password and confirm. */}
            <Grid item xs={12} md={6} >
              <InvitationSignup
                style={{ height: '100%' }}
                invitedEmail={this.state.invitedEmail}
                invitedToken={this.state.invitedToken}
                isPasswordValid={this.state.passwordAttemptValidated}
                onPasswordChange={(pass) => { this.setState({ passwordAttempt: pass }) }}
              />
            </Grid>
                        
            {/* Helper for password strongness. */}
            <Grid item xs={12} md={6} >
              <PassStrength
                passwordAttempt={this.state.passwordAttempt}
                onValidationChange={(isValidated) => { this.setState({ passwordAttemptValidated: isValidated }) }}
              />
            </Grid>

          </Grid>
        </Container>

        {/* Waiting for language load when entering the screen. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }

      </React.Fragment>
    )
  }
}

// Required to make history work.
export default withRouter(SignupLayout);


// WEBPACK FOOTER //
// ./src/components/signup/SignupLayout.js